import apiClient from './api-client';

// Market Rates (Market Color Tables)
export interface MarketColorLoanTerms {
  'Credit Spread Range'?: string;
  'Discount Margin Range'?: string;
  'Market Yield Range'?: string;
}

export interface MarketColorSector {
  sector: string;
  // Keys like "Fixed Rate Loans", "Adjustable Rate Mortgages",
  // "Ground-Up Construction", "Rehab Construction", "Transitional"
  [key: string]: string | MarketColorLoanTerms;
}

export interface MarketColorTable {
  reporting_date: string;
  title: string;
  source?: string;
  sectors: MarketColorSector[];
}

export interface MarketColorSelectData {
  reporting_date: string;
  '3 year US Treasury': string;
  '5 year US Treasury': string;
  'SOFR (3month)': string;
}

export interface MarketColorTablesResponse {
  senior_secured: MarketColorTable;
  construction_bridge: MarketColorTable;
  select_data: MarketColorSelectData;
}

export const marketRatesService = {
  async getMarketColorTables(): Promise<MarketColorTablesResponse> {
    const response = await apiClient.get(
      '/api/v1/market-rates/market-color-tables'
    );
    return response.data;
  },
};
